module.exports = __webpack_public_path__ + "img/img03.a1d9d58a.png";